import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useGetAllUsersQuery } from '../features/auth/authApi';
import { useGetAssigMarkByStdIdMutation, useGetQuizMarkByStdIdMutation } from '../features/marks/marksApi';

const LeaderBoard = () => {
  const {user:loginUser} = useSelector((state) => state.auth);


const[usersInfo,setUserInfos]=useState([]);

const[loginUserInfo,setLoginUserInfo]=useState({});

useEffect(()=>{

  const findIndex=usersInfo.sort(function(a, b){return  b?.totalMarks -a?.totalMarks
  }).findIndex(ui=>ui.email==loginUser.email);
  setLoginUserInfo({position:findIndex+ 1 ,...usersInfo.sort(function(a, b){return  b?.totalMarks -a?.totalMarks
  })?.find((u)=>u?.email==loginUser?.email)})
 
},[usersInfo,loginUser])

const {data:userList,isError,isLoading,isSuccess,error}=useGetAllUsersQuery();
const [getUserByMarksFunc,{data:userBymarks}]=useGetAssigMarkByStdIdMutation();
const [getUserByQuizMarksFunc,{data}]=useGetQuizMarkByStdIdMutation();


useEffect(()=>{
  if(userList){
userList?.filter(ua=>ua.role!=='admin').map(user=>{
  
  getUserByMarksFunc(user.id).then(resa=>
   {
 
   getUserByQuizMarksFunc(user.id).then(resq=>(setUserInfos(prev=>([...prev,{ ...prev?.[user.email] , name:user?.name , totalMarks: Number(resa?.data?.reduce((curr,ele)=>(curr+Number(ele?.mark|| 0)),0)) + Number(resq?.data?.reduce((curr,ele)=>(curr+Number(ele?.mark|| 0)),0)) , assigMark:resa?.data?.reduce((curr,ele)=>(curr+Number(ele?.mark|| 0)),0) ,email : user.email ,quizMark:resq?.data?.reduce((curr,ele)=>(curr+Number(ele?.mark|| 0)),0)}]))))

  }
    
    )

})
  }
},[userList])
let content=undefined;

if(isLoading){
  content=<p>Loading............</p>
}
else if(!isLoading && isError){
  content=<p>Something went wrong!</p>

}
else if(!isLoading && !isError && isSuccess && userList?.length==0){
  content=<p>No Videos availabe!</p>

}



else if(!isLoading && !isError && isSuccess  && userList?.length > 0){
  content=usersInfo.sort(function(a, b){return  b?.totalMarks -a?.totalMarks
 })?.slice(0,20)?.map((userr,index)=>(   <tr className="border-b border-slate-600/50">
 <td className="table-td text-center">{index + 1}</td>
 <td className="table-td text-center">{userr?.name}</td>
 <td className="table-td text-center">{userr?.quizMark}</td>
 <td className="table-td text-center">{userr?.assigMark}</td>
 <td className="table-td text-center">{userr?.totalMarks}</td>

</tr>))

}

  return (
    <>
    
      <section className="py-6 bg-primary">
  <div className="mx-auto max-w-7xl px-5 lg:px-0">
    <div>
      <h3 className="text-lg font-bold">Your Position in Leaderboard</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr>
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>
        <tbody>
          <tr className="border-2 border-cyan">
            <td className="table-td text-center font-bold">{loginUserInfo?.position}</td>
            <td className="table-td text-center">{loginUserInfo?.name}</td>
 <td className="table-td text-center">{loginUserInfo?.quizMark}</td>
 <td className="table-td text-center">{loginUserInfo?.assigMark}</td>
 <td className="table-td text-center">{loginUserInfo?.totalMarks}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div className="my-8">
      <h3 className="text-lg font-bold">Top 20 Result</h3>
      <table className="text-base w-full border border-slate-600/50 rounded-md my-4">
        <thead>
          <tr className="border-b border-slate-600/50">
            <th className="table-th !text-center">Rank</th>
            <th className="table-th !text-center">Name</th>
            <th className="table-th !text-center">Quiz Mark</th>
            <th className="table-th !text-center">Assignment Mark</th>
            <th className="table-th !text-center">Total</th>
          </tr>
        </thead>
        <tbody>
        {content}
          
        </tbody>
      </table>
    </div>
  </div>
</section>

    </>
  )
}

export default LeaderBoard